module.exports = __webpack_public_path__ + "static/media/error_icon.a2a1c8db.svg";